const actions = {
  APP_DATA_FETCH_BEGIN: 'APP_DATA_FETCH_BEGIN',
  APP_DATA_FETCH_SUCCESS: 'APP_DATA_FETCH_SUCCESS',
  APP_DATA_FETCH_ERR: 'APP_DATA_FETCH_ERR',

  appDataFetchBegin: () => ({
    type: actions.APP_DATA_FETCH_BEGIN,
  }),

  appDataFetchSuccess: (data) => ({
    type: actions.APP_DATA_FETCH_SUCCESS,
    data,
  }),

  appDataFetchErr: (err) => ({
    type: actions.APP_DATA_FETCH_ERR,
    err,
  }),
};

export const {
  APP_DATA_FETCH_BEGIN,
  APP_DATA_FETCH_SUCCESS,
  APP_DATA_FETCH_ERR,
  appDataFetchBegin,
  appDataFetchSuccess,
  appDataFetchErr,
} = actions;

export default actions;
